<div class="error-container">
  <div class="error-icon">
   <img src="images/error-illustrations.svg">
  </div>

  <h2>{{ 'error.page_not_found' | translate }}</h2>

  <p [innerHTML]="'error.error_hint' | translate">
  </p>

  <div class="error-actions">
    <a routerLink="/orders" class="link">{{ 'error.view_orders' | translate }}</a>
    <a routerLink="/shipments" class="link">{{ 'error.view_shipments' | translate }}</a>
  </div>
</div>
